import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class DokumentiPopisService {

  constructor(private _http: Http) { }

  dohvatiSve(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_sve_pisane_dokumente', a)
    .map(res => res.json());
  }
  
  dodajDokument(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'spremi_dokument', a)
    .map(res => res.json());
  }

  urediDokument(a: any){
    return this._http.put(AppConfig.apiAdresaSQL + 'uredi_dokument', a)
    .map(res => res.json());
  }

  obrisiDokument(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'obrisi_dokument', a)
    .map(res => res.json());
  }

  spremiDokument(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'download_dokument', a)
    .map(res => res.json());
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/dokumenti-popis/dokumenti-popis.service.ts